import { Injectable } from '@angular/core';
import * as signalR from '@microsoft/signalr';

import { LocalNotifications } from '@awesome-cordova-plugins/local-notifications/ngx';
// import { LocalNotifications} from '@ionic-native/local-notifications/ngx';

@Injectable({
  providedIn: 'root'
})
export class NotifyService {
  connection = new signalR.HubConnectionBuilder()
  .withUrl("https://ws.diegoevangelista.com/v1/notify")
  .build();

constructor(private notifications: LocalNotifications) {
  this.notifications.hasPermission();
  this.notifications.requestPermission();
}

startConnection(projectKey: string, idUser: string, uniqueDeviceID: string, model: string, serial: string, platform: string, version: string) {
  this.connection.start()
    .then(() => {
      this.connection.send("AddToGroup", projectKey, idUser, uniqueDeviceID, model, serial, platform, version);

      this.connection.on("receiveAllNotify", (title: string, message: string, image: string) => {
        this.notify(title, message, image)
      })

      this.connection.on("receiveNotify", (title: string, message: string, image: string) => {
        this.notify(title, message, image)
      })

    }).catch(() => console.log('Falha ao conectar!'));
}


getAllNotification() {

}



notify(title: string, text: string, img: string) {
  this.notifications.schedule({
    id: 777,
    title: title,
    //sound: isAndroid? 'file://sound.mp3': 'file://beep.caf',
    text: text,
    icon: img,
    foreground: true,
    vibrate: true,
  });
}


}
